export enum Industry {
    AIRLINES = 'AIRLINES',
    HOTEL = 'HOTEL',
    AUTO = 'AUTO'
}